module.exports = __webpack_public_path__ + "fonts/b40a8671a9e216b4ccb3c06947d7af9f.svg";